import { Target, Shield, Award } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background with Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/g4e0q0zj_xvdjloe8_shutterstock_227930497-r.jpg" 
          alt="Professional Team"
          className="w-full h-full object-cover opacity-5"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-gray-50 opacity-95"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-blue-900 mb-4">
            About FAL Consultancy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We're dedicated to becoming a valuable extension of your team, empowering you to achieve your financial goals and optimize your business performance.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="group bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-md border border-gray-100 text-center hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="bg-gradient-to-br from-blue-900 to-blue-700 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Target className="text-white" size={32} />
            </div>
            <h3 className="text-xl font-bold text-blue-900 mb-3">Our Mission</h3>
            <p className="text-gray-600 leading-relaxed">
              To deliver customized financial and accounting solutions that drive business success through secure, reliable, and innovative services.
            </p>
          </div>

          <div className="group bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-md border border-gray-100 text-center hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="bg-gradient-to-br from-blue-900 to-blue-700 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Shield className="text-white" size={32} />
            </div>
            <h3 className="text-xl font-bold text-blue-900 mb-3">Our Values</h3>
            <p className="text-gray-600 leading-relaxed">
              Integrity, security, and client success are at the heart of everything we do. We prioritize your financial security above all.
            </p>
          </div>

          <div className="group bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-md border border-gray-100 text-center hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="bg-gradient-to-br from-blue-900 to-blue-700 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Award className="text-white" size={32} />
            </div>
            <h3 className="text-xl font-bold text-blue-900 mb-3">Our Expertise</h3>
            <p className="text-gray-600 leading-relaxed">
              A team of seasoned finance and accounting professionals with deep industry knowledge and proven track records.
            </p>
          </div>
        </div>

        <div className="bg-white/90 backdrop-blur-sm p-10 rounded-xl shadow-lg border border-gray-100 max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center">
            Why Choose FAL Consultancy?
          </h3>
          <div className="space-y-4 text-gray-600 leading-relaxed">
            <p>
              FAL Consultancy Company Limited brings together experienced finance and accounting experts who understand the complexities of modern business operations. We don't just provide services—we become your trusted partner in financial success.
            </p>
            <p>
              Our approach combines traditional financial wisdom with cutting-edge data analytics, ensuring you have the insights needed to make informed decisions. Whether you're a growing startup or an established enterprise, we tailor our solutions to meet your specific needs.
            </p>
            <p>
              With our headquarters in Hong Kong, we serve clients globally, offering the perfect blend of local expertise and international standards. Let us help you unlock your business's full potential.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;